/** @jsxImportSource @emotion/react */
import React from 'react';

function CategoryItem({category, selectCategory}) {
    const click = function(e) {
        e.preventDefault();
        selectCategory(category);
    }

    const style = {
        '&:hover,&.active': {
            color: `${category.color}`,
            fill:`${category.color}`,
            'svg': {
                fill:`${category.color}`
            }
        },
    }


    return (<button css={style} onClick={click} className={category.isActive ? 'category-item active' : 'category-item'} type="submit">
        <span>{category.title}</span>
        <svg  viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path   fillRule="evenodd" clipRule="evenodd" d="M12 18.4778C8.38538 18.4778 5.45505 15.4601 5.45505 11.7377C5.45505 8.01456 8.38538 4.99685 12 4.99685C15.6146 4.99685 18.545 8.01456 18.545 11.7377C18.545 15.4601 15.6146 18.4778 12 18.4778ZM18.5112 0H5.48954C2.45781 0 0 2.53039 0 5.65253V16.7395C0 17.8775 0.33456 18.9893 0.957461 19.9284L7.3341 29.5371C8.35709 31.0786 10.0527 32 11.8655 32H12.1345C13.9473 32 15.6429 31.0786 16.6659 29.5371L23.0425 19.9284C23.6661 18.9893 24 17.8775 24 16.7395V5.65253C24 2.53039 21.5422 0 18.5112 0Z" />
        </svg>
    </button>);
}

export default React.memo(CategoryItem);
